<template>
	<li class="category-item">
		<label class="category-item__label">
<!--			<a v-if="type == 'package'" href="javascript:" @click="onCatClick(category.id)" class="js-get-packages-cat" :data-id="category.id">-->
<!--				<SvgIcon v-if="type != 'package'" class="category-item__ico" :iconName="category.ico"/>-->
<!--				<img v-if="type == 'package'" :src="category.img">-->
<!--				{{ category.name }}-->
<!--			</a>-->
			<a :href="category.url">
				<SvgIcon v-if="type != 'package'" class="category-item__ico" :iconName="category.ico"/>
				<img v-if="type == 'package'" :src="category.img">
				{{ category.name }}
			</a>
		</label>
	</li>
</template>

<script>
import SvgIcon from '../base/SvgIcon/SvgIcon.vue' ;
import axios from 'axios';

export default {
	components: {
		SvgIcon
	},
	props: {
		category: {
			type: Object,
			required: true
		},
		type: String
	},
	methods: {
		getCategory: function(catID, catName) {
			const data = {
				text: this.getSearchText,
				cat: catID,
				dish: this.getFilterDish,
				event: this.getFilterEvent,
				people: this.getFilterPeople,
				price: this.getFilterPrice
			};

			const payload = {
				catID: catID,
				catName: catName
			};

			this.$store.dispatch('setSearchCat', payload);
			this.$store.dispatch('setSearchProducts', data);
		},
		onCatClick: function(e) {
			axios.post('/wp-json/fws/v1/search-products-by-package', {term: e})
				.then(response => {
					// this.events = response.data;
					const wrap = document.getElementsByClassName('js-item-listing-wrap');
					const mainTitle = document.getElementsByClassName('js-our-packages__title');
					const catLabel = document.getElementsByClassName('js-cat-label');
					const searchInput = document.getElementsByClassName('js-search-box__input');
					searchInput[0].setAttribute('term-id', e);
					// eslint-disable-next-line no-undef
					if (response.data.content) {
						//console.log(response.data.content);
						wrap[0].innerHTML = '';
						wrap[0].innerHTML = response.data.content;
						mainTitle[0].innerHTML = response.data.catTitle;
						catLabel[0].innerHTML = response.data.catTitle;
						searchInput[0].setAttribute('placeholder', 'Searching in ' + response.data.catTitle + '...');
					} else {
						wrap[0].innerHTML = response.data.text;
					}
				})
				.catch(error => console.log(error));
		}
	},
	computed: {
		searchText() {
			return this.$store.getters.getSearchText;
		},
		searchCat() {
			return this.$store.getters.getSearchCat;
		},
		getFilterDish() {
			return this.$store.getters.getChosenFilterDishType;
		},
		getFilterEvent() {
			return this.$store.getters.getChosenFilterEventType;
		},
		getFilterPeople() {
			return this.$store.getters.getChosenFilterPeople;
		},
		getFilterPrice() {
			return this.$store.getters.getChosenFilterPrice;
		}
	}
};
</script>

<style lang="scss" scoped>
.category-item {
	font-size: 15px;
	line-height: 1;
	text-transform: uppercase;
	letter-spacing: 0.75px;
	width: 16.66%;
	padding-right: 25px;
	margin-bottom: 35px;
	transition: color $dur $ease;
	display: flex;

	&:hover {
		color: $burning-orange;
	}

	@include mq($lg) {
		width: 33.33%;
	}

	@include mq($md) {
		width: 50%;
		margin-bottom: 20px;
	}

	@include mq($sm) {
		width: 100%;
	}
}

.category-item__label {
	display: inline-flex;
	align-items: center;

	a {
		display: flex;
		align-items: center;

		img {
			width: 28px;
			height: 28px;
			margin-right: 30px;
		}
	}
}

.category-item__check {
	display: none;
}

.category-item__ico {
	/* display: inline-block; */
	display: flex;
	font-size: 33px;
	height: 36px;
	margin-right: 25px;
}
</style>
